import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import * as constants from './constants'

export { constants }

export const createLoanSearchNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'loan_search',
  text: translateFn('mnu_loans_view'),
  identity: '/secure/loan/search',
  permission: 'VIEW_LOAN',
}))

export default Loadable(() => import('./Components'))
